var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcticonCommentDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M2.406.375C1.077.375 0 1.452 0 2.781v13.063c0 1.328 1.078 2.406 2.406 2.406h1.719v2.122c0 .81.488 1.54 1.237 1.85.748.31 1.61.139 2.183-.434l3.539-3.538h8.51c1.329 0 2.406-1.077 2.406-2.406V2.78C22 1.452 20.923.375 19.594.375H2.406zm-.344 2.406c0-.19.154-.344.344-.344h17.188c.19 0 .343.154.343.344v13.063c0 .19-.153.344-.343.344h-8.938c-.273 0-.535.109-.729.302l-3.74 3.74v-3.011c0-.57-.461-1.032-1.03-1.032h-2.75c-.19 0-.345-.153-.345-.343V2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11CEEF",
    fillRule: "nonzero",
    d: "M30.938 11.031c0-.19-.154-.344-.344-.344H25.78c-.57 0-1.031-.461-1.031-1.03 0-.57.462-1.032 1.031-1.032h4.813c1.328 0 2.406 1.078 2.406 2.406v13.063c0 1.329-1.077 2.406-2.406 2.406h-1.719v2.122c0 .81-.488 1.54-1.237 1.85-.748.31-1.61.139-2.183-.434L21.916 26.5h-7.135c-1.329 0-2.406-1.077-2.406-2.406v-2.015c0-.57.462-1.03 1.031-1.03.57 0 1.031.46 1.031 1.03v2.015c0 .19.155.343.344.343h7.563c.273 0 .535.11.729.303l3.74 3.74v-3.011c0-.57.461-1.032 1.03-1.032h2.75c.19 0 .345-.153.345-.343V11.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcticonCommentDiscussion);
export default __webpack_public_path__ + "static/media/octicon-comment-discussion.69322344e0e160c5527a687ca5fa1e78.svg";
export { ForwardRef as ReactComponent };